import { useConfigContext } from '../context';
import { setApiBaseUrl, setAuthTokenKey, setAccessedFrom } from '../api/api-service';
export const useSetApiConfig = () => {
    const { config: { apiBaseUrl, tokenKey, accessed_from }, } = useConfigContext();
    // Set synchronously during render so AUTH_TOKEN_KEY, API_BASE_URL, etc. are
    // configured before any child component's API hooks evaluate their `enabled`
    // condition and fire requests. Using useEffect here caused a one-render delay
    // that resulted in unauthenticated requests (401) on every page load.
    setAuthTokenKey(tokenKey);
    setApiBaseUrl(apiBaseUrl);
    setAccessedFrom(accessed_from);
};
